import "../styles/AquaFlowPromo.scss";
import aquaflow from "../assets/marketing/boiler.png";
import aquaflow_graph from "../assets/marketing/boiler_graph.png";

const Boiler = () => {
  return (
    <section className="aqua-flow-promo">
      <img src={aquaflow} alt="Aqua Flow Banner" className="top-image" />

      <div className="features">
        <div>
          <h3>MAIOR ÁREA DE MANUTENÇÃO</h3>
          <p>
            Acesso facilitado para limpeza, reparos e inspeções, garantindo a
            vida útil do seu reservatório e mais espaço para trabalhar com
            conforto e segurança.
          </p>
        </div>
        <div>
          <h3>SOLUÇÃO COMPLETA EM AQUECIMENTO DE ÁGUA!</h3>
          <p>
            O novo reservatório térmico da Komeco foi projetado para oferecer a
            você a melhor experiência em aquecimento de água, com foco na
            praticidade e na durabilidade.
          </p>
        </div>
        <div>
          <h3>MAIOR ROBUSTEZ E PRATICIDADE</h3>
          <p>NOVA CINTA DE INOX + CAPA DE ALUMÍNIO POR DENTRO E POR FORA</p>
        </div>
      </div>

      <div className="button-wrapper">
        <a
          href={`https://wa.me/555391425203?text=Olá%2C+tenho+interesse+em+seus+serviços+de+${"boilers"}.`}
          target="_blank"
          style={{ color: "inherit" }}
        >
          <button>Solicite seu orçamento</button>
        </a>
      </div>

      <img
        src={aquaflow_graph}
        alt="Gráfico de desempenho"
        className="bottom-image"
      />
    </section>
  );
};

export default Boiler;
